import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=6a262336&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=ts&"
export * from "./Maintenance.vue?vue&type=script&lang=ts&"
import style0 from "./error-page.scss?vue&type=style&index=0&id=6a262336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a262336",
  null
  
)

export default component.exports